var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_down-24px 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.73675 8.58084L7.00008 6.31751L9.26342 8.58084C9.49092 8.80834 9.85842 8.80834 10.0859 8.58084C10.3134 8.35334 10.3134 7.98584 10.0859 7.75834L7.40842 5.08084C7.18092 4.85334 6.81342 4.85334 6.58592 5.08084L3.90842 7.75834C3.68092 7.98584 3.68092 8.35334 3.90842 8.58084C4.13592 8.80251 4.50925 8.80834 4.73675 8.58084Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.41497a4444a715f0b70d1332d9a0c9b8.svg";
export { ForwardRef as ReactComponent };